import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';

//declare function ire(string,{}): any;
@Component({
  selector: 'app-trinka-vs-grammarly',
  templateUrl: './trinka-vs-grammarly.component.html',
  styleUrls: ['./trinka-vs-grammarly.component.scss']
})
export class TrinkaVsGrammarlyComponent implements OnInit {
  userDateSelect: Date;
  grammarlySelect: string = "";
  getUserDate: any;
  finalTextContent: boolean = false;
  compareTrinkaGrammarly: FormGroup;
  disabledSubmitButton: boolean = true;
  userEmailId: any;


  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private formBuilder: FormBuilder,
    private LinkService: LinkService,
    private fb: FormBuilder,
  ) { 
    this.compareTrinkaGrammarly = fb.group({
      'userEmailId': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])]
    });
  }

  @HostListener('input') oninput() {
    if (this.compareTrinkaGrammarly.valid) {
      this.disabledSubmitButton = false;
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Grammarly以外の英文添削ツールをお探しなら-AI搭載英文チェッカーTrinka');
    this.metaTagService.updateTag({ name: 'description', content: '「Trinkaを使いたいけれど、Grammarly Premiumの料金を支払い済み・・・。」そんな方にも無駄なくTrinkaのプレミアムプランにお乗り換えいただけるよう、お得な乗り換え方法をご用意しています' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Grammarly以外の英文添削ツールをお探しなら-AI搭載英文チェッカーTrinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: '「Trinkaを使いたいけれど、Grammarly Premiumの料金を支払い済み・・・。」そんな方にも無駄なくTrinkaのプレミアムプランにお乗り換えいただけるよう、お得な乗り換え方法をご用意しています' });
    // this.metaTagService.updateTag({ name: 'keywords', content: 'check grammar mistake online, grammar checker for essay, grammar fixer, check grammar for free' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/trinka-vs-grammarly' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });    
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Grammarly以外の英文添削ツールをお探しなら-AI搭載英文チェッカーTrinka" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "「Trinkaを使いたいけれど、Grammarly Premiumの料金を支払い済み・・・。」そんな方にも無駄なくTrinkaのプレミアムプランにお乗り換えいただけるよう、お得な乗り換え方法をご用意しています" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinka-vs-grammarly' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinka-vs-grammarly' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  diffDays: any = 0;
  currentDate = new Date();
  getdifference() {
    if (typeof this.userDateSelect == "undefined" || this.grammarlySelect == "") {
      this.diffDays = 0
      return;
    } else {
      let currentDate = new Date();
      let diffTime;
      if (this.grammarlySelect == "Y") {
        let yearDate = new Date(this.userDateSelect.getFullYear() + 1, this.userDateSelect.getMonth(), this.userDateSelect.getDate());
        diffTime = Math.abs(yearDate.getTime() - this.userDateSelect.getTime());
      } else if (this.grammarlySelect == "M") {
        let monthDate = new Date(this.userDateSelect.getFullYear(), this.userDateSelect.getMonth(), this.userDateSelect.getDate() + 30);
        diffTime = Math.abs(monthDate.getTime() - this.userDateSelect.getTime());
      }
      let ext_days;
      ext_days = Math.ceil((this.userDateSelect.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

      this.diffDays = (Math.ceil(diffTime / (1000 * 60 * 60 * 24))) + ext_days;
    }
  }

  premiumDateChanged(event) {
    this.userDateSelect = new Date(event.target.valueAsNumber);
    this.getdifference();
  }

  planTypeChanged(event) {
    console.log(event);
    this.grammarlySelect = event.target.value;
    this.getdifference();
    if(this.grammarlySelect== ''){
      this.finalTextContent = false;  
    }
    else{
      this.finalTextContent = true;  
    }
  }
  onSubmitEmail(){
    if(this.compareTrinkaGrammarly.valid){
      var CloudURL = "https://cloud.trinka.ai/signup/";
      // var CloudURL = "http://localhost:4201/signup/";
      this.userEmailId = this.compareTrinkaGrammarly.value.userEmailId;
      window.location.href = CloudURL + getEncodedEmailId(this.userEmailId);
    }
  }

  

}

function getEncodedEmailId(userEmailId) { 
  return encodeURIComponent(btoa(userEmailId));
}
